
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17 5.8h-1.6a2.958 2.958 0 00.2-1 2.875 2.875 0 00-.7-1.8 2.41 2.41 0 00-1.8-.7A3.4 3.4 0 0010 4.4a3.684 3.684 0 00-3.2-2.2 2.465 2.465 0 00-1.7.8 2.504 2.504 0 00-.8 1.8 2.958 2.958 0 00.2 1H3a.789.789 0 00-.8.8V10a.789.789 0 00.8.8h.7V17a.789.789 0 00.8.8h11.2a.789.789 0 00.8-.8v-6.2h.5a.789.789 0 00.8-.8V6.5a.773.773 0 00-.8-.7zm-.8 3.4h-5.4v-2h5.5v2zm-3-5.4a.908.908 0 01.7.3.908.908 0 01.3.7 1.493 1.493 0 01-.3.7.908.908 0 01-.7.3H11c.3-.9 1-2 2.2-2zM6.1 5.5a2.118 2.118 0 01-.3-.7 2.614 2.614 0 01.3-.8.779.779 0 01.7-.3c1.1 0 1.8 1.1 2.1 2H6.8c-.2.1-.5-.1-.7-.2zM3.8 7.2h5.5v2H3.8zm1.4 3.6h4.1v5.5H5.2zm9.7 5.4h-4.1v-5.4h4.1z"}})])
          )
        }
      }
    